// extracted by mini-css-extract-plugin
export default {"legal-page-content":"LegalPages_legal-page-content__55Bhg","list-title":"LegalPages_list-title__8CaQK"};